import React from 'react';
import { Stack } from '@chakra-ui/react';
import { useAccess } from 'hooks';

import { BankAccounts, Whitelist } from './components';

const FinanceTab: React.FC = () => {
  const access = useAccess();

  return (
    <Stack
      w="100%"
      alignItems="stretch"
      flexDir={{ base: 'column', xl: 'row' }}
      justifyContent="space-between"
      gap={4}
      my={{ base: 4, md: 8 }}
    >
      {access.whiteListCryptoWithdrawalService && <Whitelist />}
      {access.bankAccountListPermission && <BankAccounts />}
    </Stack>
  );
};

export default FinanceTab;
